import { render, staticRenderFns } from "./VehicleCostsOverview.vue?vue&type=template&id=46b2d12f&scoped=true"
import script from "./VehicleCostsOverview.vue?vue&type=script&lang=js"
export * from "./VehicleCostsOverview.vue?vue&type=script&lang=js"
import style0 from "./VehicleCostsOverview.vue?vue&type=style&index=0&id=46b2d12f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b2d12f",
  null
  
)

export default component.exports